import { canPlay } from '../../constants';

const checkUrlExclusions = [canPlay.youtube];

export const checkUrlIsOnlineExclusion = (link: string) =>
  checkUrlExclusions.some((checkIsExcluded) => checkIsExcluded(link));
